export const pagesTestSetsEn = {
  detail: {
    basicInfo: {
      fields: {
        relatedRelease: 'Related Release',
        testLevel: 'Test Level',
        testPlan: 'Test Plan',
        testType: 'Test Type'
      },
      title: 'Basic Information'
    },
    breadcrumb: {
      home: 'Home',
      testSets: 'Test Sets'
    },
    conditions: {
      actions: 'Behaviors to Verify',
      constraints: 'Constraints & Dependency Rules',
      excludedSuffix: ' (Excluded)',
      factorLabel: 'Factor: {{name}}',
      factors: 'Factors & Levels',
      levelsLabel: 'Levels',
      noResults: 'No test conditions are registered.'
    },
    coverage: {
      placeholder: 'Coverage and technique matrices are coming soon.',
      sectionTitle: 'Test Coverage / Test Techniques'
    },
    designJudgement: {
      fields: {
        designMemo: 'Design Judgement Notes',
        regressionRequired: 'Regression Required',
        relatedTickets: 'Related Tickets',
        riskObservation: 'Risk Observations'
      },
      regressionRequiredOptions: {
        notRequired: 'Not Required',
        required: 'Required'
      },
      relatedTickets: {
        empty: 'No related tickets'
      },
      sectionTitle: 'Design Judgement & Traceability'
    },
    header: {
      fields: {
        automationRatio: 'Automation',
        itemCount: 'Items',
        ownerNotSet: 'Not set',
        product: 'Product',
        targetVersion: 'Target Version'
      }
    },
    options: {
      testSetLevel: {
        INTEGRATION: 'Integration',
        SYSTEM: 'System',
        UAT: 'UAT',
        UNIT: 'Unit'
      },
      testSetScope: {
        ABNORMAL: 'Abnormal',
        NORMAL: 'Normal',
        OTHER: 'Other',
        SEMI_NORMAL: 'Semi-Normal'
      },
      testSetStatus: {
        APPROVED: 'Approved',
        DESIGNING: 'Designing',
        EXECUTED: 'Executed',
        IMPLEMENTING: 'Implementing',
        NOT_EXECUTED: 'Not Executed',
        READY: 'Ready'
      },
      testSetType: {
        ACCESSIBILITY: 'Accessibility',
        COMPATIBILITY: 'Compatibility',
        FUNCTIONAL: 'Functional',
        INTEROPERABILITY: 'Interoperability',
        MAINTENANCE: 'Maintenance',
        NON_FUNCTIONAL: 'Non-Functional',
        OTHER: 'Other',
        PERFORMANCE: 'Performance',
        PORTABILITY: 'Portability',
        RELIABILITY: 'Reliability',
        SECURITY: 'Security',
        USABILITY: 'Usability'
      }
    },
    pageTitle: 'Test Set Detail',
    sidebar: {
      basicInfo: 'Basic Information',
      coverage: 'Test Coverage',
      dataRequirement: 'Data Requirements',
      designJudgement: 'Design Judgement',
      target: 'Test Target',
      technique: 'Test Technique'
    },
    tabs: {
      conditions: 'Test Conditions',
      items: 'Test Items',
      profile: 'Profile',
      results: 'Test Results',
      targetFunctions: 'Target Functions'
    },
    targetFunctions: {
      noResults: 'No target functions are scoped for this test set.',
      table: {
        headers: {
          kind: 'Type',
          name: 'Name',
          publishStatus: 'Status'
        },
        kind: {
          FUNCTION: 'Function',
          MODULE: 'Module',
          PRODUCT: 'Product',
          SUB_MODULE: 'Sub Module'
        }
      }
    },
    testData: {
      fields: {
        requiredTestDataTypes: 'Required Test Data Types',
        testDataNotes: 'Test Data Notes',
        testDataPrecondition: 'Test Data Precondition'
      },
      sectionTitle: 'Test Data Requirements'
    },
    testItemResult: {
      aiExecution: 'AI Execution',
      backToList: 'Back to Test Items',
      executionSource: {
        AI_AUTO: 'AI Automated',
        EXTERNAL: 'External',
        MANUAL: 'Manual'
      },
      fields: {
        actualResult: 'Actual Result',
        durationMs: 'Duration',
        evaluation: 'Evaluation',
        evidence: 'Evidence',
        executedAt: 'Executed At',
        executionExecutedAt: 'Execution Time',
        executionSource: 'Execution Source',
        executor: 'Executor',
        expectedResult: 'Expected Result',
        precondition: 'Precondition',
        procedure: 'Procedure',
        target: 'Target'
      },
      genericTitle: 'Test Result Detail',
      notExecuted: 'Not executed',
      pageTitle: 'Test Result Detail',
      sections: {
        definition: 'Test Definition',
        executionLog: 'Execution Log',
        result: 'Execution Result'
      }
    },
    testItems: {
      caseType: {
        ABNORMAL: 'Abnormal',
        BOUNDARY: 'Boundary',
        NORMAL: 'Normal'
      },
      columns: {
        aiExecution: 'AI Execution',
        caseType: 'Type',
        condition: 'Test Condition',
        evaluation: 'Evaluation',
        expectedResult: 'Expected Result',
        linkedIssues: 'Linked Defects',
        procedure: 'Procedure',
        target: 'Target'
      },
      evaluation: {
        BLOCKED: 'Blocked',
        NG: 'NG',
        NOT_EXECUTED: 'Not Executed',
        OK: 'OK',
        SKIP: 'Skipped'
      },
      filterPlaceholder: 'Search by target, procedure, or expected result',
      noResults: 'No test items match the current filter.',
      tabs: {
        all: 'All',
        blocked: 'Blocked',
        ng: 'NG',
        notExecuted: 'Not Executed',
        ok: 'OK',
        skip: 'Skipped'
      }
    },
    testTarget: {
      fields: {
        designDescription: 'Description',
        designScopes: 'Design Scopes'
      },
      sectionTitle: 'Test Target'
    }
  },
  list: {
    columns: {
      defectTicketCount: 'Defect Tickets',
      ngCount: 'NG',
      okCount: 'OK',
      owner: 'Owner',
      periodFrom: 'Start Date',
      periodTo: 'End Date',
      product: 'Product',
      skipCount: 'Skipped',
      status: 'Status',
      targetVersion: 'Target Version',
      testSetName: 'Test Set Name'
    },
    filterPlaceholder: 'Search by test set name',
    noResults: 'No test sets matched the current filter.',
    pageTitle: 'Test Sets',
    tabLabel: 'Test Set List',
    tabs: {
      all: 'All',
      approved: 'Approved',
      designing: 'Designing',
      executed: 'Executed',
      implementing: 'Implementing',
      notExecuted: 'Not Executed',
      ready: 'Ready'
    }
  }
};